import { Box, TextField, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { colors } from '../../theme/colors';

interface ResourceCountSectionProps {
  disabled: boolean;
  onChange: (value: number) => void;
  value: number;
}

const ResourceCountSection: FC<ResourceCountSectionProps> = ({
  disabled,
  onChange,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      maxWidth={540}
      sx={{ alignItems: 'center', display: 'flex', gap: 2, mb: 1, mt: 2 }}
    >
      <Typography
        color={colors['gray-700']}
        sx={{ minWidth: 120 }}
        variant="text-xs"
      >
        {t('resource-count')}
      </Typography>
      <TextField
        disabled={disabled}
        inputProps={{ min: 0 }}
        onChange={(e) => {
          const num = e.target.value === '' ? 0 : Number(e.target.value);
          onChange(Math.max(0, Math.round(num)));
        }}
        size="small"
        sx={{
          '& .MuiInputBase-input': {
            color: colors['gray-700'],
            fontSize: '14px',
          },
          '& .MuiInputBase-root': { height: 40, marginTop: 0 },
          flex: 1,
          maxWidth: 412,
        }}
        type="number"
        value={value ?? ''}
      />
    </Box>
  );
};

export default ResourceCountSection;
